let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6tXwk")).then(() => parcelRequire('glEdp'));